import { frontEndLogs } from "./frontEndLogs";
import { analyticsClickEvent, firebaseLoadingEvent } from '../../action/firebaseAnalytics/firebaseAnalytics';

export const handleRefreshTheScreen= (screen) => {
    const performanceEntries = performance.getEntriesByType('navigation');
    console.log('performanceEntries',performanceEntries,screen);
    if (performanceEntries.length && performanceEntries[0].type === 'reload') {
      frontEndLogs("The "+screen+" page is reloaded - "+sessionStorage.getItem('applicationId'),false,200,'handleRefreshTheScreen');
      firebaseLoadingEvent('page_reloaded', '')
    }
}

export const handlePopstate= () => {
    frontEndLogs("On the browser back or forward button was clicked - " + sessionStorage.getItem('applicationId'), false, 200, 'handlePopstate');
    analyticsClickEvent('page_back_or_forward_clicked', '')
}